import React from 'react';

interface ButtonBadgeProps {
  text?: string;
}

export const ButtonBadge: React.FC<ButtonBadgeProps> = ({ text }) => {
  return (
    <>
      {typeof text !== 'undefined' && (
        <div className="absolute -bottom-[12px] -right-[5px] hidden rounded-3xl border border-solid border-cardAnswerButtonColor bg-badgeColor px-[5px] py-0 font-RobotoCondensed text-[12px] font-semibold tracking-[0px] text-cardAnswerButtonColor sm:block ">
          {text.toUpperCase()}
        </div>
      )}
    </>
  );
};
